import { connect } from 'react-redux'
import { createSelector } from 'reselect'
import { State } from 'interfaces/state'
import OnboardingProperty, { OnboardingPropertyStateProps } from 'components/features/pfm/OnboardingProperty/OnboardingProperty'
import { memberInfoSelector } from 'selectors/globalSelectors'
import internal from 'components/utils/Internal'

const mapStateToProps = createSelector(
  memberInfoSelector,
  (member) => ({
    firstName: member
      ? member.first_name
      : null,
    isBlocked: Boolean(member && member.is_blocked),
  })
) as (state: State) => OnboardingPropertyStateProps

const OnboardingPropertyContainer = internal(
  connect<OnboardingPropertyStateProps>(
    mapStateToProps
  )(OnboardingProperty)
)
export default OnboardingPropertyContainer
